import React from 'react'

import DevOnly from '../utils/DevOnly'
import ReloadButton from './ReloadButton'

const UnhandledErrorMessage: React.FC<{ error?: unknown }> = () => {
  return (
    <section className="position-relative">
      <h2>Sorry, something went wrong.</h2>

      <ReloadButton />

      <p>
        We've encountered an issue on our end. Our team has already been
        notified and is working to resolve it as quickly as possible.
      </p>

      <p>Please refresh this page to try again.</p>

      <DevOnly>
        <div className="d-flex flex-column">
          <ul>
            <li>
              <a
                href={`${import.meta.env.VITE_API_URL}/_profiler/latest`}
                target="_blank"
                rel="noreferrer"
              >
                View last API request
              </a>
            </li>

            <li>
              <a
                href={`${import.meta.env.VITE_API_URL}/_profiler/search?limit=10`}
                target="_blank"
                rel="noreferrer"
              >
                View last 10 API requests
              </a>
            </li>
          </ul>
        </div>
      </DevOnly>
    </section>
  )
}

export default UnhandledErrorMessage
